import { useEffect, useState } from "react"
import { useTranslations } from "@cirrus/core/i18n/provider"
import { Context, News, NewsService } from "./types"

export const useRequestHandler = (service: NewsService) => {
  const { i18n } = useTranslations()
  const [state, setState] = useState<Context>({
    loading: false, data: null, error: null
  })
  
  useEffect(() => {
    (async () => {
      try {
        setState((prev) => ({ ...prev, loading: true, error: null }))
        const { data } = await service.getNews()
        setState({
          loading: false,
          data: data ?? new News({ text: i18n("General:NoNews") }),
          error: null
        })
      } catch (error) {
        setState((prev) => ({ ...prev, loading: false, error }))
      }
    })()
  }, [])
  
  return state
}